import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Dialog, DialogTitle, Select, MenuItem, TextField, DialogActions, DialogContent } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Close from '@material-ui/icons/Close';
import { options, label } from '../../../../components/FlowConfigurationForms/TimeManagement/Schedule/config';
import triggerService from "../../../../services/triggerService/triggerService";
import { useSetRecoilState } from 'recoil';
import { alertState } from '../../../../recoil-store/recoil-state';

const useStyles = makeStyles((theme) => ({
  input: {
    backgroundColor: '#f2f2f2',
    color: '#d6d6d6'
  },
  bottomSection: {
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%'
  },
  formControl: {
    backgroundColor: '#F2F2F2 !important',
    width: '100%'
  },
  selectEmpty: {
    marginTop: theme.spacing(2)
  },
  select: {
    padding: '10px 24px 10px 10px',
    fontSize: 12,
    fontWeight: 600
  },
  button: {
    border: 'none',
    borderRadius: '5px',
    width: 100,
    height: 35,
    float: 'right',
    '&:focus': {
      outline: 'none'
    }
  },
  submit: {
    color: 'white',
    marginLeft: 15,
    backgroundColor: '#079063',
    cursor: 'pointer'
  }
}));

const Schedule = ({ setOpen, schedule, automId }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [profile, setProfile] = useState({ trigger_profile_id: undefined, trigger_rule_id: undefined });
  const [scheduleType, setScheduleType] = useState('once');
  const [startDate, setStartDate] = useState('');
  const [specifiedDate, setSpecifiedDate] = useState();
  const [specifiedDay, setSpecifiedDay] = useState([]);
  const [specifiedMonth, setSpecifiedMonth] = useState([]);
  const [endDate, setEndDate] = useState('');
  const [specifiedTime, setSpecifiedTime] = useState('');
  const [minute, setMinute] = useState('1');
  const setAlert = useSetRecoilState(alertState);
  const profileType = "SCHEDULE";

  useEffect(() => {
    if (automId !== undefined && automId !== null) {
      async function fetchData() {
        const resp = await triggerService.getTriggerProfileByAutomId(automId, profileType);
        if (resp && resp.status && resp.code === 200) {
          const period = resp.data.trigger_rule.period;
          setScheduleType(period.scheduleType);
          if (period.scheduleType === 'once') {
            setSpecifiedDate(period.specifiedDate);
          } else if (period.scheduleType === 'minute') {
            setStartDate(period.startDate);
            setEndDate(period.endDate);
            setMinute(period.minute);
          } else if (period.scheduleType === 'daily') {
            setStartDate(period.startDate);
            setEndDate(period.endDate);
          } else if (period.scheduleType === 'weekly') {
            setEndDate(period.endDate);
            setSpecifiedTime(period.specifiedTime);
            setSpecifiedDay(options.dropdownDay.data.filter(x => period.specifiedDay.find(y => x.value == y.value)))
          } else if (period.scheduleType === 'monthly') {
            setEndDate(period.endDate);
            setSpecifiedTime(period.specifiedTime);
            setSpecifiedDay(options.dropdownDays.data.filter(x => period.specifiedDay.find(y => x.value == y.value)))
            setSpecifiedMonth(options.dropdownMonth.data.filter(x => period.specifiedMonth.find(y => x.value == y.value)))
          }
          setProfile({ trigger_profile_id: resp.data.id, trigger_rule_id: resp.data.trigger_rule.id })
        }
      }
      fetchData();
    }
  }, [automId])



  const handleClose = () => {
    setOpen(false);
  };

  const AddZero = (item) => {
    if (item < 10) {
      return "0" + item;
    }
    return item;
  }

  const handleSelect = (event, setState) => {
    if (event.target.value === 'monthly' || event.target.value === 'weekly') {
      setSpecifiedDay([]);
      setSpecifiedMonth([]);
    }
    setEndDate('');
    setCurrentStartDate();
    setState(event.target.value);
  };

  const setCurrentStartDate = () => {
    const currentDate = new Date();
    const dateTime = `${currentDate.getFullYear()}-${AddZero(currentDate.getMonth() + 1)}-${AddZero(currentDate.getDate())}T${AddZero(currentDate.getHours())
      }:${AddZero(currentDate.getMinutes())}`;
    setStartDate(dateTime);
  }

  async function handleSubmit() {
    let newForm;
    if (scheduleType === 'once') {
      newForm = { scheduleType, specifiedDate };
    } else if (scheduleType === 'minute') {
      newForm = { scheduleType, startDate, endDate, minute };
    } else if (scheduleType === 'daily') {
      newForm = { scheduleType, startDate, endDate };
    } else if (scheduleType === 'weekly') {
      newForm = { scheduleType, specifiedDay, endDate, specifiedTime };
    } else if (scheduleType === 'monthly') {
      newForm = { scheduleType, specifiedMonth, endDate, specifiedTime, specifiedDay };
    }
    setOpen(false);
    const newData = {
      period: JSON.stringify(newForm),
      autom_id: automId,
      type: profileType,
      trigger_profile_id: profile.trigger_profile_id,
      trigger_rule_id: profile.trigger_rule_id
    };
    const response = await triggerService.createProfile(newData);
    if (response) {
      if (response?.status) {
        setAlert(alert => ({ ...alert, show: true, message: t("MESSAGES.TRIGGER." + response.message), severity: 'success' }));
        setProfile({ trigger_profile_id: response.data.trigger_profile_id, trigger_rule_id: response.data.trigger_rule_id })
      } else {
        setAlert(alert => ({ ...alert, show: true, message: response.message, severity: 'error' }));
      }
    }
  }
  return (
    <Dialog open onClose={handleClose} PaperProps={{ style: { overflowX: 'hidden', minWidth: 400 } }}>
      <DialogTitle id="alert-dialog-title">
        <div id="about-title">
          <b>{t('CONTENT.LIBRARY.TIME-MANAGEMENT.ACTION.SCHEDULE')}</b>
          <Button onClick={handleClose}><Close /></Button>
        </div>
      </DialogTitle>
      <DialogContent>
        <div style={{ textAlign: 'left', marginTop: 5 }}>
          <div className="form-element">
            <div style={{ marginBottom: 5 }}>{t(label + 'TIMING-TYPE')}</div>
            <Select classes={{ root: classes.select }} value={scheduleType} onChange={(e) => handleSelect(e, setScheduleType)} variant="outlined" fullWidth>
              <MenuItem classes={{ root: classes.select }} value="once">{t(label + 'ONLY-ONCE')}</MenuItem>
              <MenuItem classes={{ root: classes.select }} value="minute">{t(label + 'MINUTE')}</MenuItem>
              <MenuItem classes={{ root: classes.select }} value="daily">{t(label + 'DAILY')}</MenuItem>
              <MenuItem classes={{ root: classes.select }} value="weekly">{t(label + 'WEEKLY')}</MenuItem>
              <MenuItem classes={{ root: classes.select }} value="monthly">{t(label + 'MONTHLY')}</MenuItem>
            </Select>
          </div>
        </div>
        {scheduleType === 'once' && (
          <div className="form-element">
            {t(label + 'DATE-TIME')}
            <TextField type="datetime-local" fullWidth value={specifiedDate}
              onChange={e => setSpecifiedDate(e.target.value)}
              InputLabelProps={{ shrink: true }} size="small"
            />
          </div>
        )}
        {scheduleType === 'minute' && (
          <div>
            <div className="form-element">
              {t(label + 'START-DATE-TIME')}
              <TextField type="datetime-local" fullWidth value={startDate}
                onChange={e => { e.target.value != '' ? setStartDate(e.target.value) : setCurrentStartDate() }}
                InputLabelProps={{ shrink: true }} size="small"
              />
            </div>
            <div className="form-element">
              {t(label + 'MINUTE')}
              <TextField type="number" fullWidth value={minute}
                onChange={e => setMinute(e.target.value)}
                InputLabelProps={{ shrink: true }}
              />
            </div>
            <div className="form-element">
              {t(label + 'END-DATE')}
              <TextField type="datetime-local" fullWidth value={endDate}
                onChange={e => setEndDate(e.target.value)}
                InputLabelProps={{ shrink: true }}
              />
            </div>
          </div>
        )}
        {scheduleType === 'daily' && (
          <div>
            <div className="form-element">
              {t(label + 'START-DATE-TIME')}
              <TextField type="datetime-local" fullWidth value={startDate}
                onChange={e => { e.target.value != '' ? setStartDate(e.target.value) : setCurrentStartDate() }}
                InputLabelProps={{ shrink: true }}
              />
            </div>
            <div className="form-element">
              {t(label + 'END-DATE')}
              <TextField type="date" fullWidth value={endDate}
                onChange={e => setEndDate(e.target.value)}
                InputLabelProps={{ shrink: true }}
              />
            </div>
          </div>
        )}
        {scheduleType === 'weekly' && (
          <div>
            <div className="form-element">
              {t(label + 'DAY')}
              <Autocomplete multiple value={specifiedDay}
                options={options.dropdownDay.data}
                getOptionLabel={option => { return `${t(option.label)}`; }}
                renderInput={params => <TextField {...params} variant="outlined" />}
                onChange={(e, value) => setSpecifiedDay(value)}
                filterSelectedOptions size="small"
              />
            </div>
            <div className="form-element">
              {t(label + 'TIME')}
              <TextField type="time" value={specifiedTime} fullWidth
                onChange={e => setSpecifiedTime(e.target.value)}
                InputLabelProps={{ shrink: true }} size="small"
              />
            </div>
            <div className="form-element">
              {t(label + 'END-DATE')}
              <TextField type="date" fullWidth value={endDate}
                onChange={e => setEndDate(e.target.value)}
                InputLabelProps={{ shrink: true }} size="small"
              />
            </div>
          </div>
        )}
        {scheduleType === 'monthly' && (
          <div>
            <div className="form-element">
              {t(label + 'MONTH')}
              <Autocomplete multiple value={specifiedMonth}
                options={options.dropdownMonth.data}
                getOptionLabel={option => { return `${t(option.label)}`; }}
                onChange={(e, value) => setSpecifiedMonth(value)}
                renderInput={params => <TextField {...params} variant="outlined" />}
                filterSelectedOptions size="small"
              />
            </div>
            <div className="form-element">
              {t(label + 'DAY')}
              <Autocomplete multiple value={specifiedDay}
                options={options.dropdownDays.data}
                getOptionLabel={option => { return `${t(option.label)}`; }}
                onChange={(e, value) => setSpecifiedDay(value)}
                renderInput={params => <TextField {...params} variant="outlined" />}
                filterSelectedOptions size="small"
              />
            </div>
            <div className="form-element">
              <TextField type="time" fullWidth value={specifiedTime}
                onChange={e => setSpecifiedTime(e.target.value)}
                InputLabelProps={{ shrink: true }}
              />
            </div>
            <div className="form-element">
              {t(label + 'END-DATE')}
              <TextField type="date" fullWidth value={endDate}
                onChange={e => setEndDate(e.target.value)}
                InputLabelProps={{ shrink: true }} size="small"
              />
            </div>
          </div>
        )}
      </DialogContent>
      <DialogActions style={{ justifyContent: 'space-between', padding: '8px 24px 16px 24px' }}>
        <div className={classes.bottomSection}>
          <button type="button" onClick={handleSubmit} className={`${classes.button} ${classes.submit}`}
            style={{ backgroundColor: '#46474E', borderRadius: 2, border: 'none', color: '#fff' }}
          >
            {t('CONTENT.AUTOMS-LIST.EDIT')}
          </button>
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default Schedule;
